import { styled } from '../../config'

export const Tag = styled('span', {
  display: 'inline-flex',
  gap: '4px',
  padding: '4px 8px',
  userSelect: 'none',
  borderRadius: 4,
  boxSizing: 'border-box',
  cursor: 'default',
  alignItems: 'center',
  justifyContent: 'center',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '12px',
  lineHeight: '12px',
  fontFamily: '$DMSans',
  variants: {
    variant: {
      default: {
        color: '$blackA900',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: '$blackA100',
        '&:hover': { borderColor: '$blackA500' },
        '&:active': { borderColor: '$blackA900' }
      },
      success: {
        color: '$white',
        background: '$indigo0600',
        '&:hover': { borderColor: '$indigo0500' },
        '&:active': { borderColor: '$indigo0400' }
      },
      disabled: {
        pointerEvents: 'none',
        color: '$blackA400',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: '$blackA050'
      }
    }
  },
  defaultVariants: {
    variant: 'default'
  }
})
